"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forumTypes = exports.PostsToDeleteMap = exports.ExtendedPostId = exports.PollInput = exports.PrivilegedActor = exports.Category = exports.Thread = exports.Post = exports.Poll = exports.PollAlternative = exports.VecPostId = exports.VecThreadId = exports.VecCategoryId = exports.OptionCategoryId = exports.PostReactionId = exports.CategoryId = exports.ModeratorId = exports.ForumUserId = void 0;
const types_1 = require("@polkadot/types");
const common_1 = require("./common");
class ForumUserId extends types_1.u64 {
}
exports.ForumUserId = ForumUserId;
class ModeratorId extends types_1.u64 {
}
exports.ModeratorId = ModeratorId;
class CategoryId extends types_1.u64 {
}
exports.CategoryId = CategoryId;
class PostReactionId extends types_1.u64 {
}
exports.PostReactionId = PostReactionId;
class OptionCategoryId extends types_1.Option.with(CategoryId) {
}
exports.OptionCategoryId = OptionCategoryId;
class VecCategoryId extends types_1.Vec.with(CategoryId) {
}
exports.VecCategoryId = VecCategoryId;
class VecThreadId extends types_1.Vec.with(common_1.ThreadId) {
}
exports.VecThreadId = VecThreadId;
class VecPostId extends types_1.Vec.with(common_1.PostId) {
}
exports.VecPostId = VecPostId;
class PollAlternative extends (0, common_1.JoyStructDecorated)({
    alternative_text_hash: common_1.Hash,
    vote_count: types_1.u32,
}) {
}
exports.PollAlternative = PollAlternative;
class Poll extends (0, common_1.JoyStructDecorated)({
    description_hash: common_1.Hash,
    end_time: types_1.u64,
    poll_alternatives: types_1.Vec.with(PollAlternative),
}) {
}
exports.Poll = Poll;
class Post extends (0, common_1.JoyStructDecorated)({
    thread_id: common_1.ThreadId,
    text_hash: common_1.Hash,
    author_id: ForumUserId,
    cleanup_pay_off: types_1.u128,
    last_edited: types_1.u32,
}) {
}
exports.Post = Post;
class Thread extends (0, common_1.JoyStructDecorated)({
    category_id: CategoryId,
    author_id: ForumUserId,
    poll: types_1.Option.with(Poll),
    cleanup_pay_off: types_1.u128,
    number_of_posts: types_1.u64,
}) {
}
exports.Thread = Thread;
class Category extends (0, common_1.JoyStructDecorated)({
    title_hash: common_1.Hash,
    description_hash: common_1.Hash,
    archived: types_1.bool,
    num_direct_subcategories: types_1.u32,
    num_direct_threads: types_1.u32,
    num_direct_moderators: types_1.u32,
    parent_category_id: types_1.Option.with(CategoryId),
    sticky_thread_ids: types_1.Vec.with(common_1.ThreadId),
}) {
}
exports.Category = Category;
class PrivilegedActor extends (0, common_1.JoyEnum)({
    Lead: types_1.Null,
    Moderator: ModeratorId,
}) {
}
exports.PrivilegedActor = PrivilegedActor;
class PollInput extends (0, common_1.JoyStructDecorated)({
    description: types_1.Bytes,
    end_time: types_1.u64,
    poll_alternatives: types_1.Vec.with(types_1.Bytes),
}) {
}
exports.PollInput = PollInput;
class ExtendedPostId extends (0, common_1.JoyStructDecorated)({
    category_id: CategoryId,
    thread_id: common_1.ThreadId,
    post_id: common_1.PostId,
}) {
}
exports.ExtendedPostId = ExtendedPostId;
class PostsToDeleteMap extends types_1.BTreeMap.with(ExtendedPostId, types_1.bool) {
}
exports.PostsToDeleteMap = PostsToDeleteMap;
exports.forumTypes = {
    ForumUserId,
    ModeratorId,
    CategoryId,
    PostReactionId,
    Category,
    Thread,
    Post,
    PollAlternative,
    Poll,
    PrivilegedActor,
    PollInput,
    // runtime alias
    ThreadOf: Thread,
    ExtendedPostId,
};
exports.default = exports.forumTypes;
